import { render } from "./share.vue?vue&type=template&id=31b806dc"
const script = {}

import exportComponent from "D:\\WorkPlace\\MINE\\dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__